import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../logo.svg";

export default function Header() {
  const logoRef = useRef(null);

  useEffect(() => {
    const el = logoRef.current;
    if (!el) return;

    // add the animation class once
    el.classList.add("spin-once");

    // remove class after animation ends so it won't rerun on re-render
    const onAnimEnd = () => el.classList.remove("spin-once");
    el.addEventListener("animationend", onAnimEnd);

    return () => el.removeEventListener("animationend", onAnimEnd);
  }, []);

  return (
    <header className="w-full py-4 sm:py-6 flex justify-center items-center">
      <Link
        to="/"
        className="text-4xl sm:text-4xl font-poppins 
                   bg-gradient-to-r from-blue-300 to-blue-500 
                   bg-clip-text text-transparent 
                   hover:scale-[1.03] active:scale-[0.98]
                   transition-transform duration-300 text-center drop-shadow-md
                   leading-tight"
      >
        <span className="block sm:inline">Personal </span>
        <img
          ref={logoRef}
          src={logo}
          alt="Personal Finance Logo"
          className="inline-block w-12 h-12 sm:w-12 sm:h-12 flex-shrink-0"
        />
        <span className="block sm:inline sm:ml-2">Finance</span>
      </Link>
    </header>
  );
}
